export const profiles = [
  {
    id: 1,
    type: "stilesRailsProfile",
    label: "Square",
  },
  {
    id: 2,
    type: "stilesRailsProfile",
    label: "Bevel",
  },
];

export const fullboundProfileOptions = [
  {
    id: 1,
    type: "fullboundProfile",
    label: "Door Profile",
  },
  {
    id: 2,
    type: "fullboundProfile",
    label: "Window Profile",
  },
];

export const bifoldAlumStiles = [
  {
    id: 1,
    type: "stilesRailsProfile",
    label: "Square",
  },
];